// extracted by mini-css-extract-plugin
export default {"bar":"UserNav_bar__96TO3","root":"UserNav_root__iVs5Y","tab":"UserNav_tab__GhBRF"};